module.exports = __webpack_public_path__ + "static/media/help-white.f46ed5ba.svg";